import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tp-course-filter-area tp-course-filter-bg p-relative pt-180 pb-220" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "tp-breadcrumb__content-filter mb-50" }
const _hoisted_6 = { class: "tp-breadcrumb__list" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  width: "17",
  height: "14",
  viewBox: "0 0 17 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.07207 0C8.19331 0 8.31107 0.0404348 8.40664 0.114882L16.1539 6.14233L15.4847 6.98713L14.5385 6.25079V12.8994C14.538 13.1843 14.4243 13.4574 14.2225 13.6589C14.0206 13.8604 13.747 13.9738 13.4616 13.9743H2.69231C2.40688 13.9737 2.13329 13.8603 1.93146 13.6588C1.72962 13.4573 1.61597 13.1843 1.61539 12.8994V6.2459L0.669148 6.98235L0 6.1376L7.7375 0.114882C7.83308 0.0404348 7.95083 0 8.07207 0ZM8.07694 1.22084L2.69231 5.40777V12.8994H13.4616V5.41341L8.07694 1.22084Z",
    fill: "currentColor"
  })
], -1 /* HOISTED */)
const _hoisted_8 = { class: "color" }
const _hoisted_9 = { class: "tp-breadcrumb__title" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = { class: "tp-course-filter-top-left d-flex align-items-center" }
const _hoisted_14 = { class: "tp-course-filter-top-tab tp-tab mb-20" }
const _hoisted_15 = {
  class: "nav nav-tabs",
  id: "filterTab",
  role: "tablist"
}
const _hoisted_16 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_17 = {
  class: "nav-link active",
  id: "courses-grid-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#courses-grid",
  type: "button",
  role: "tab",
  "aria-controls": "courses-grid",
  "aria-selected": "true"
}
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.66667 1H1V5.66667H5.66667V1Z\" stroke=\"#031F42\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M12.9997 1H8.33301V5.66667H12.9997V1Z\" stroke=\"#031F42\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M12.9997 8.33337H8.33301V13H12.9997V8.33337Z\" stroke=\"#031F42\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M5.66667 8.33337H1V13H5.66667V8.33337Z\" stroke=\"#031F42\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)
const _hoisted_19 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_20 = {
  class: "nav-link",
  id: "courses-grid-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#courses-list",
  type: "button",
  role: "tab",
  "aria-controls": "courses-list",
  "aria-selected": "false"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 16 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 7.11108H1",
    stroke: "#031F42",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 1H1",
    stroke: "#031F42",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 13.2222H1",
    stroke: "#031F42",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "tp-course-filter-top-result mb-20" }, [
  /*#__PURE__*/_createCommentVNode("                      <p>Showing 1–14 of 26 results</p>")
], -1 /* HOISTED */)
const _hoisted_23 = { class: "col-lg-6" }
const _hoisted_24 = { class: "tp-course-filter-top-right d-flex align-items-center justify-content-start justify-content-lg-end" }
const _hoisted_25 = { class: "tp-course-filter-top-right-search d-none d-lg-block mb-20" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.625 12.625L16 16",
      stroke: "#8B8B8B",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M14.5 7.75C14.5 4.02208 11.4779 1 7.75 1C4.02208 1 1 4.02208 1 7.75C1 11.4779 4.02208 14.5 7.75 14.5C11.4779 14.5 14.5 11.4779 14.5 7.75Z",
      stroke: "#8B8B8B",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "tp-course-filter-select mb-20" }
const _hoisted_30 = {
  class: "wide",
  "data-model": "filters.sort"
}
const _hoisted_31 = {
  selected: "",
  default: "",
  hidden: "",
  disabled: ""
}
const _hoisted_32 = { value: "creation desc" }
const _hoisted_33 = { value: "enrollment_count" }
const _hoisted_34 = { value: "avg_rating" }
const _hoisted_35 = { value: "course_price desc" }
const _hoisted_36 = { class: "tp-filter-mt-2" }
const _hoisted_37 = { class: "container" }
const _hoisted_38 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_39 = {
  class: "tab-pane fade show active",
  id: "courses-grid",
  role: "tabpanel",
  "aria-labelledby": "courses-grid-tab"
}
const _hoisted_40 = { class: "row" }
const _hoisted_41 = {
  key: 0,
  class: "col-lg-12 col-md-12 animate__animated animate__zoomIn"
}
const _hoisted_42 = {
  class: "tp-course-item p-relative fix mb-30 d-flex align-items-center justify-content-center",
  style: {"height":"380px"}
}
const _hoisted_43 = { class: "tp-error-wrapper text-center" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h4", { class: "tp-error-title" }, "Oops!", -1 /* HOISTED */)
const _hoisted_45 = { class: "tp-error-content" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h4", { class: "tp-error-title-sm" }, "Not Data Found...", -1 /* HOISTED */)
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<div class=\"tp-course-item p-relative fix mb-30 placeholder-glow\"><div class=\"tp-course-teacher mb-15\"><div class=\"d-flex align-items-center gap-1\"><span class=\"placeholder d-inline-block rounded-circle\" style=\"width:30px;height:30px;\"></span><span class=\"placeholder d-inline-block rounded\" style=\"width:80px;height:10px;\"></span></div></div><div class=\"tp-course-thumb\"><span class=\"placeholder d-block rounded\" style=\"height:200px;\"></span></div><div class=\"tp-course-content\"><div class=\"d-flex align-items-center gap-1 mb-10\"><span class=\"placeholder d-inline-block rounded\" style=\"width:100px;height:25px;\"></span></div><div class=\"tp-course-meta\"><div class=\"d-flex align-items-center gap-1\"><span class=\"placeholder d-inline-block rounded\" style=\"width:80px;height:10px;\"></span><span class=\"placeholder d-inline-block rounded\" style=\"width:80px;height:10px;\"></span></div></div><span class=\"placeholder d-block rounded mt-4 mb-1\" style=\"width:80%;height:6px;\"></span><span class=\"placeholder d-block rounded\" style=\"width:30%;height:6px;\"></span></div></div>", 1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  class: "tab-pane fade",
  id: "courses-list",
  role: "tabpanel",
  "aria-labelledby": "courses-grid-tab"
}
const _hoisted_50 = { class: "tp-course-filter-thumb" }
const _hoisted_51 = ["src", "alt"]
const _hoisted_52 = { class: "tp-course-filter-content" }
const _hoisted_53 = { class: "tp-course-filter-tag d-flex align-items-center justify-content-between mb-10" }
const _hoisted_54 = { class: "tag-span" }
const _hoisted_55 = { class: "tp-course-rating-star" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", null, " /5", -1 /* HOISTED */)
const _hoisted_57 = { class: "tp-course-rating-icon" }
const _hoisted_58 = { class: "course-star-rating" }
const _hoisted_59 = /*#__PURE__*/_createStaticVNode("<div class=\"back-stars\"><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i></div>", 1)
const _hoisted_60 = /*#__PURE__*/_createStaticVNode("<i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i>", 5)
const _hoisted_65 = [
  _hoisted_60
]
const _hoisted_66 = { class: "tp-course-filter-title" }
const _hoisted_67 = { class: "tp-course-filter-meta" }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = ["src"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "14",
  viewBox: "0 0 15 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.9228 10.0426V2.29411C13.9228 1.51825 13.2949 0.953997 12.5252 1.01445H12.4847C11.1276 1.12529 9.07163 1.82055 7.91706 2.53596L7.80567 2.6065C7.62337 2.71733 7.30935 2.71733 7.11692 2.6065L6.9549 2.50573C5.81046 1.79033 3.75452 1.1152 2.3974 1.00437C1.62768 0.943911 0.999756 1.51827 0.999756 2.28405V10.0426C0.999756 10.6573 1.50613 11.2417 2.12393 11.3122L2.30622 11.3425C3.70386 11.5238 5.87126 12.2392 7.10685 12.9143L7.1372 12.9244C7.30937 13.0252 7.59293 13.0252 7.75498 12.9244C8.99057 12.2393 11.1681 11.5339 12.5758 11.3425L12.7885 11.3122C13.4164 11.2417 13.9228 10.6674 13.9228 10.0426Z",
    stroke: "#94928E",
    "stroke-width": "1.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.46118 2.81787V12.4506",
    stroke: "#94928E",
    "stroke-width": "1.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "15",
  viewBox: "0 0 13 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.57134 7.5C8.36239 7.5 9.81432 6.04493 9.81432 4.25C9.81432 2.45507 8.36239 1 6.57134 1C4.7803 1 3.32837 2.45507 3.32837 4.25C3.32837 6.04493 4.7803 7.5 6.57134 7.5Z",
    stroke: "#94928E",
    "stroke-width": "1.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.1426 14C12.1426 11.4845 9.64553 9.44995 6.57119 9.44995C3.49684 9.44995 0.999756 11.4845 0.999756 14",
    stroke: "#94928E",
    "stroke-width": "1.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */)
const _hoisted_72 = { class: "tp-course-filter-p" }
const _hoisted_73 = { class: "tp-course-filter-pricing d-flex align-items-center justify-content-between" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = { class: "tp-course-filter-btn" }
const _hoisted_77 = { class: "tp-event-inner-pagination pt-30 pb-50" }
const _hoisted_78 = /*#__PURE__*/_createStaticVNode("<section class=\"banner-area pb-40\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"tp-banner-sm-2-wrap mb-60\"><h3 class=\"tp-banner-sm-2-title\">Earn a <br><span>Certificate <img class=\"tp-underline-shape-11 wow bounceIn\" data-wow-duration=\"1.5s\" data-wow-delay=\".4s\" src=\"/assets/lms_website/website-assets/img/unlerline/banner-2-svg-1.svg\" alt=\"\"></span></h3><div class=\"tp-banner-sm-2-btn\"><a href=\"course-with-filter.html\">View Programs</a></div><div class=\"tp-banner-sm-2-shape-1\"><img src=\"/assets/lms_website/website-assets/img/banner/banner-2-thumb-1.png\" alt=\"\"></div></div></div><div class=\"col-lg-6\"><div class=\"tp-banner-sm-2-wrap tp-banner-sm-2-bg-2 mb-60\"><h3 class=\"tp-banner-sm-2-title\">Best <br>Rated <span>Courses <img class=\"tp-underline-shape-11 wow bounceIn\" data-wow-duration=\"1.5s\" data-wow-delay=\".4s\" src=\"/assets/lms_website/website-assets/img/unlerline/banner-2-svg-2.svg\" alt=\"\"></span></h3><div class=\"tp-banner-sm-2-btn\"><a href=\"course-with-filter.html\">View Programs</a></div><div class=\"tp-banner-sm-2-shape-1\"><img src=\"/assets/lms_website/website-assets/img/banner/banner-2-thumb-2.png\" alt=\"\"></div></div></div></div></div></section>", 1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_CourseWidget = _resolveComponent("CourseWidget")
  const _component_Pagination = _resolveComponent("Pagination")

  return (_openBlock(), _createElementBlock("main", null, [
    _createCommentVNode(" course filter start "),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", null, [
                  _createVNode(_component_router_link, { to: { name: 'home' } }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _createElementVNode("span", _hoisted_8, _toDisplayString($data.lms_website.__('All Courses')), 1 /* TEXT */)
              ]),
              _createElementVNode("h3", _hoisted_9, _toDisplayString($data.lms_website.__('All Courses')), 1 /* TEXT */),
              (!$data.courses.loading)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    innerHTML: $data.lms_website.__('We have the largest collection of {0} courses', [`<span>${$data.count}</span>`])
                  }, null, 8 /* PROPS */, _hoisted_10))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", {
              style: _normalizeStyle(($data.courses.loading)?'visibility: hidden':''),
              class: "tp-course-filter-wrap p-relative"
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("ul", _hoisted_15, [
                        _createElementVNode("li", _hoisted_16, [
                          _createElementVNode("button", _hoisted_17, [
                            _hoisted_18,
                            _createTextVNode(" " + _toDisplayString($data.lms_website.__('Grid')), 1 /* TEXT */)
                          ])
                        ]),
                        _createElementVNode("li", _hoisted_19, [
                          _createElementVNode("button", _hoisted_20, [
                            _hoisted_21,
                            _createTextVNode(" " + _toDisplayString($data.lms_website.__('List')), 1 /* TEXT */)
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_22
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        type: "search",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.search_value) = $event)),
                        placeholder: $data.lms_website.__('Search for Courses...')
                      }, null, 8 /* PROPS */, _hoisted_26), [
                        [_vModelText, $data.search_value]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "tp-course-filter-top-right-search-btn",
                        onClick: _cache[1] || (_cache[1] = $event => ($data.filters.search=$data.search_value))
                      }, _hoisted_28)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("select", _hoisted_30, [
                        _createElementVNode("option", _hoisted_31, _toDisplayString($data.lms_website.__('Short by')), 1 /* TEXT */),
                        _createElementVNode("option", _hoisted_32, _toDisplayString($data.lms_website.__('Latest')), 1 /* TEXT */),
                        _createElementVNode("option", _hoisted_33, _toDisplayString($data.lms_website.__('Trending')), 1 /* TEXT */),
                        _createElementVNode("option", _hoisted_34, _toDisplayString($data.lms_website.__('Most Rated')), 1 /* TEXT */),
                        _createElementVNode("option", _hoisted_35, _toDisplayString($data.lms_website.__('Price: Low to High')), 1 /* TEXT */)
                      ])
                    ])
                  ])
                ])
              ])
            ], 4 /* STYLE */)
          ])
        ])
      ])
    ]),
    _createCommentVNode(" course filter end "),
    _createCommentVNode(" course filter area start "),
    _createElementVNode("section", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              (!$data.courses.loading && !$data.courses.list.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _createElementVNode("p", null, [
                            _createTextVNode("Sorry, we couldn't find any courses like "),
                            _createElementVNode("b", null, _toDisplayString($data.filters.search), 1 /* TEXT */),
                            _createTextVNode(".")
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "tp-btn-inner",
                            onClick: _cache[2] || (_cache[2] = $event => ($data.search_value=''))
                          }, _toDisplayString($data.lms_website.__('Show All Courses')), 1 /* TEXT */)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (!$data.courses.loading)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($options.paginatedCCourses, (course) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-lg-4 col-md-6 animate__animated animate__zoomIn",
                      key: course.name
                    }, [
                      _createVNode(_component_CourseWidget, { course: course }, null, 8 /* PROPS */, ["course"])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              ($data.courses.loading)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList($options.range(1, 3), (number) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-lg-4 col-md-6",
                      key: number
                    }, _hoisted_48))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.courses.list, (course) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "tp-course-filter-item mb-25 d-flex animate__animated animate__zoomIn",
                key: course.name
              }, [
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_component_router_link, {
                    to: `/courses/view/${course.name}`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "course-sky",
                        src: (course.image)?course.image:'/assets/lms_website/images/placeholder.jpg',
                        alt: course.title
                      }, null, 8 /* PROPS */, _hoisted_51)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("span", _hoisted_54, _toDisplayString($data.lms_website.__(course.tags)), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(course.avg_rating), 1 /* TEXT */),
                        _hoisted_56
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _hoisted_59,
                          _createElementVNode("div", {
                            class: "front-stars",
                            style: _normalizeStyle('width:'+$options.avg_rating_width(course.avg_rating))
                          }, _hoisted_65, 4 /* STYLE */)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("h4", _hoisted_66, [
                    _createVNode(_component_router_link, {
                      to: `/courses/view/${course.name}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.clip($data.lms_website.__(course.title), 75)), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    (course.instructor?.name)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_68, [
                          _createElementVNode("img", {
                            src: (course.instructor.user_image)?course.instructor.user_image:'/assets/lms_website/images/user.png',
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_69),
                          _createTextVNode(" " + _toDisplayString(course.instructor?.full_name), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("span", null, [
                      _hoisted_70,
                      _createTextVNode(" " + _toDisplayString(course.lesson_count) + " " + _toDisplayString($data.lms_website.__('Lessons')), 1 /* TEXT */)
                    ]),
                    _createElementVNode("span", null, [
                      _hoisted_71,
                      _createTextVNode(" " + _toDisplayString(course.enrollment_count) + " " + _toDisplayString($data.lms_website.__('Students')), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("p", null, _toDisplayString($options.clip(course.short_introduction, 140)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    (!course.paid_course)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString($data.lms_website.__('Free')), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (course.paid_course)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString($options.format_currency(course.course_price)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_76, [
                      _createVNode(_component_router_link, {
                        to: `/courses/view/${course.name}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($data.lms_website.__('Preview this Course')), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                    ])
                  ])
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _createElementVNode("div", _hoisted_77, [
          (!$data.courses.loading)
            ? (_openBlock(), _createBlock(_component_Pagination, {
                key: 0,
                "current-page": $data.courses.currentPage,
                "total-items": $data.courses.list?.length,
                "items-per-page": $data.courses.itemsPerPage,
                onPageChanged: $options.handlePageChange
              }, null, 8 /* PROPS */, ["current-page", "total-items", "items-per-page", "onPageChanged"]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createCommentVNode(" course filter area end "),
    _createCommentVNode(" bannner-area-start "),
    _hoisted_78,
    _createCommentVNode(" bannner-area-end ")
  ]))
}